module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/mobile-application-dev/mobile-application-dev.component.css
// module id = ./src/app/components/mobile-application-dev/mobile-application-dev.component.css
// module chunks = main